<template>

    <crud-container :name="name">

        <crud-nav>
            <crud-nav-header title="RFMs" :active-filter="activeFilter" :filterables="filterables"></crud-nav-header>


            <crud-nav-scroll>
                <div v-for="(rfms,groupedKey) in groupedItems">
                    <heading size="small">{{ groupedKey }}</heading>
                    <ul>
                        <li v-for="rfm in rfms">
                            <div class="name">
                                <a href="#" @click.prevent="viewItem(rfm)">#{{ rfm.reference }} by {{
                                    rfm.created_by.name }}</a>
                            </div>
                        </li>
                    </ul>
                </div>

            </crud-nav-scroll>
        </crud-nav>

        <crud-main>
            <crud-view>
                <crud-main-header :title="current_item.reference" can-delete="true" can-edit="true"
                                  can-go-back-to-nav="true"
                                  :item="current_item"></crud-main-header>

                <dl v-if="viewing_item">
                    <template v-if="current_item.package">
                      <dt>Package</dt>
                      <dd>{{ current_item.package }}</dd>
                    </template>
                    <dt>Status</dt>
                    <dd>{{ current_item.status }}</dd>
                    <dt>Additional</dt>
                    <dd>{{ current_item.additional }}</dd>
                    <dt v-if="current_item.acknowledged_by.id">Acknowledged By</dt>
                    <dd v-if="current_item.acknowledged_by.id">{{ current_item.acknowledged_by.name }}</dd>
                    <dt v-if="current_item.closed_by.id">Closed By</dt>
                    <dd v-if="current_item.closed_by.id">{{ current_item.closed_by.name }}</dd>
                    <dt v-if="current_item.actioned_by.id">Actioned By</dt>
                    <dd v-if="current_item.actioned_by.id">{{ current_item.actioned_by.name }}</dd>
                    <dt>Requested By</dt>
                    <dd>{{ current_item.created_by.name }}</dd>
                    <dt>Requested For / Due</dt>
                    <dd>{{ current_item.due }}</dd>
                    <dt>Deliver To</dt>
                    <dd>{{ current_item.delivery_string }}</dd>
                </dl>
                <hr/>
                <heading size="small">Materials Requested <small class="ml-2">{{ current_item.manual ? 'Manually Typed' : 'Chosen From List' }}</small></heading>

                <ul class="bg-gray-100 rounded mb-3 p-4" v-if="current_item && !current_item.manual && current_item.materials && current_item.materials.length">
                  <li class="" v-for="material in current_item.materials">{{ material.quantity }} x {{ material.name }}</li>
                </ul>

                <div class="bg-gray-100 rounded p-4 whitespace-pre" v-else>{{ current_item.material_list }}</div>


                <div class="py-4 flex flex-col md:flex-row-reverse">

                  <ui-button class="sm:ml-2" colour="green" v-if="current_item.status_id == 100" @click.prevent="acknowledgeRFM(current_item)">
                    <i class="fas fa-check-circle"></i> Acknowledge
                  </ui-button>

                  <ui-button class="sm:ml-2" colour="blue" @click.prevent="copyToDD(current_item)">
                    <i class="fas fa-copy"></i> Copy To Dispatch Docket
                  </ui-button>

                  <ui-button class="" v-if="current_item.status_id < 300" colour="gray" @click.prevent="closeRFM(current_item)">
                    <i class="fas fa-times-circle"></i> Mark Closed
                  </ui-button>

                </div>

            </crud-view>
            <crud-new>
                <crud-main-header title="Create New RFM" can-go-back-to-nav="true"></crud-main-header>

                <crud-errors :errors="errors"></crud-errors>
                <div>
                    <dl>
                        <dt>Deliver To</dt>
                        <dd>
                            <label class="inline-radio-label">Not Specified</label><input class="inline-radio-input" type="radio"
                                                                                 value=""
                                                                                 v-model="new_item.delivery"/>
                            <label class="inline-radio-label">To Yard</label><input class="inline-radio-input"
                                                                                      type="radio" value="yard"
                                                                                      v-model="new_item.delivery"/>
                            <label class="inline-radio-label">To Site</label><input class="inline-radio-input" type="radio"
                                                                                   value="site"
                                                                                   v-model="new_item.delivery"/>
                            <label class="inline-radio-label">Custom</label><input class="inline-radio-input" type="radio"
                                                                                  value="custom"
                                                                                  v-model="new_item.delivery"/>
                        </dd>
                        <template v-if="new_item.delivery === 'custom'">
                          <dt>Delivery Address</dt>
                          <dd><textarea-autosize v-model="new_item.manual_address"></textarea-autosize></dd>
                        </template>
                        <dt>Requested For / Due</dt>
                        <dd>
                            <flat-pickr v-model="new_item.due" placeholder="When is this request due..."></flat-pickr>
                        </dd>
                        <dt>Notes</dt>
                        <dd><textarea-autosize v-model="new_item.additional"></textarea-autosize></dd>
                        <dt>Material Selection</dt>
                        <dd>
                            <label class="inline-radio-label">Enter Manually</label><input class="inline-radio-input" type="radio"
                                                                                 value="manual"
                                                                                 v-model="new_item.input_type"/>
                            <label class="inline-radio-label">Choose From List</label><input class="inline-radio-input"
                                                                                      type="radio" value="choose"
                                                                                      v-model="new_item.input_type"/>
                        </dd>
                    </dl>
                    <hr/>
                    <heading size="small">Materials Requested</heading>
                    
                    <div class="bg-gray-100 rounded p-4" v-if="new_item.input_type === 'choose'">
                        
                        <ul class="mb-3" v-if="new_item && new_item.materials && new_item.materials.length">
                            <li class="rounded p-4 mb-1 last:mb-0 bg-white text-lg font-bold text-brand flex flex-row" v-for="material in new_item.materials">
                                <span>{{ material.quantity }} x {{ material.name }}</span><a class="ml-auto mt-1 text-red-500 hover:text-red-400" href="#" @click.prevent="deleteMaterialNew(material)"><i class="fa fa-trash"></i></a>
                            </li>
                        </ul>
                        
                        <div class="py-2 flex flex-col md:flex-row">
                            <input class="w-24" type="number" v-model="new_material.quantity" placeholder="Qty"/>
                            <span class="m-2">x</span>
                            <v-select class="w-full" v-model="new_material.id" placeholder="Select material..." :options="materials"></v-select>
                        </div>
                        
                        <div class="py-1 flex flex-col md:flex-row-reverse">
                            <ui-button size="medium" colour="blue" @click.prevent="addMaterial()"><i class="fas fa-plus-circle mr-1"></i> Add To List</ui-button>
                        </div>
                        
                    </div>
                    <div v-else>
                        <textarea-autosize v-model="new_item.material_list" placeholder="Type your materials here..."></textarea-autosize>
                    </div>
                    
                </div>


                <div class="py-4 flex flex-col md:flex-row-reverse">
                    <ui-button class="sm:ml-2" colour="green" @click.prevent="addItem()">
                      <i class="fas fa-plus-circle mr-1"></i> Create RFM
                    </ui-button>
                    <ui-button class="sm:hidden" colour="gray" @click.prevent="backToNav()">
                      <i class="fas fa-arrow-circle-left"></i> Back
                    </ui-button>
                </div>


            </crud-new>
            <crud-edit>
                <crud-main-header :title="'Editing RFM: '+current_item.reference" can-delete="true" can-edit="true"
                                  can-go-back="true" :item="current_item"></crud-main-header>

                <crud-errors :errors="errors"></crud-errors>

                <dl v-if="viewing_item">
                    <dt>Status</dt>
                    <dd><select v-model="current_item.status_id">
                        <option value="100">Pending</option>
                        <option value="200">Acknowledged</option>
                        <option value="300">Closed</option>
                    </select></dd>

                  <dt>Deliver To</dt>
                  <dd>
                    <label class="inline-radio-label">Not Specified</label><input class="inline-radio-input" type="radio"
                                                                                  value=""
                                                                                  v-model="current_item.delivery"/>
                    <label class="inline-radio-label">To Yard</label><input class="inline-radio-input"
                                                                            type="radio" value="yard"
                                                                            v-model="current_item.delivery"/>
                    <label class="inline-radio-label">To Site</label><input class="inline-radio-input" type="radio"
                                                                            value="site"
                                                                            v-model="current_item.delivery"/>
                    <label class="inline-radio-label">Custom</label><input class="inline-radio-input" type="radio"
                                                                            value="custom"
                                                                            v-model="current_item.delivery"/>
                  </dd>
                  <template v-if="current_item.delivery === 'custom'">
                    <dt>Delivery Address</dt>
                    <dd><textarea-autosize v-model="current_item.manual_address"></textarea-autosize></dd>
                  </template>
                  <dt>Requested For / Due</dt>
                  <dd>
                    <flat-pickr v-model="current_item.due" placeholder="When is this request due..."></flat-pickr>
                  </dd>
                  <dt>Notes</dt>
                  <dd><textarea-autosize v-model="current_item.additional"></textarea-autosize></dd>
                  <dt>Material Selection</dt>
                  <dd>
                    <label class="inline-radio-label">Enter Manually</label><input class="inline-radio-input" type="radio"
                                                                                   value="manual"
                                                                                   v-model="current_item.input_type"/>
                    <label class="inline-radio-label">Choose From List</label><input class="inline-radio-input"
                                                                                     type="radio" value="choose"
                                                                                     v-model="current_item.input_type"/>
                  </dd>
                </dl>

                <hr/>
                <heading size="small">Materials Requested</heading>

                <div class="bg-gray-100 rounded p-4" v-if="current_item.input_type === 'choose'">

                  <ul class="mb-3" v-if="current_item && current_item.materials && current_item.materials.length">
                    <li class="rounded p-4 mb-1 last:mb-0 bg-white text-lg font-bold text-brand flex flex-row" v-for="material in current_item.materials">
                      <span>{{ material.quantity }} x {{ material.name }}</span><a class="ml-auto mt-1 text-red-500 hover:text-red-400" href="#" @click.prevent="deleteMaterialNew(material)"><i class="fa fa-trash"></i></a>
                    </li>
                  </ul>

                  <div class="py-2 flex flex-col md:flex-row">
                    <input class="w-24" type="number" v-model="new_material_current.quantity" placeholder="Qty"/>
                    <span class="m-2">x</span>
                    <v-select class="w-full" v-model="new_material_current.id" placeholder="Select material..." :options="materials"></v-select>
                  </div>

                  <div class="py-1 flex flex-col md:flex-row-reverse">
                    <ui-button size="medium" colour="blue" @click.prevent="addMaterialCurrent()"><i class="fas fa-plus-circle mr-1"></i> Add To List</ui-button>
                  </div>

                </div>
                <div v-else>
                  <textarea-autosize v-model="current_item.material_list" placeholder="Type your materials here..."></textarea-autosize>
                </div>


              <div class="py-4 flex flex-col md:flex-row-reverse">
                <ui-button class="sm:ml-2" colour="green" @click.prevent="saveItem()">
                  <i class="fas fa-plus-circle mr-1"></i> Update RFM
                </ui-button>
                <ui-button class="sm:hidden" colour="gray" @click.prevent="backToItem()">
                  <i class="fas fa-arrow-circle-left"></i> Back
                </ui-button>
              </div>


            </crud-edit>
        </crud-main>

    </crud-container>
</template>

<script>
    import vSelect from "vue-select";
    import flatPickr from 'vue-flatpickr-component';

    export default {
        components: {
            vSelect, flatPickr
        },
        props: ['packageId'],
        data() {
            return {
                activeFilter: 'pending',
                filterables: {
                  pending: "Pending",
                  acknowledged: "Acknowledged",
                  closed: "Closed",
                  all: "All",
                },
                name: 'rfms',
                items: [],
                current_item: {},
                new_item: {},
                new_material_current: {},
                new_material: {},
                materials: [],
                errors: null
            }
        },
        watch: {},
        computed: {
            viewing_item() {
                return !_.isEmpty(this.current_item);
            },
            groupedItems() {
                return _.groupBy(this.items, 'status');
            }
        },
        methods: {
            acknowledgeRFM: function(){
              this.current_item.status_id = 200;
              this.saveItem();
            },
            closeRFM: function(){
              this.current_item.status_id = 300;
              this.saveItem();
            },

            saveItem: function () {
                var that = this;
                var editingItem = $.extend({}, this.current_item);
                var formDataObject = new FormData();
                var saveUrl = appUrls.rfm.update.replace('REPLACEME', editingItem.id);

                editingItem.materials = _.reduce(editingItem.materials, function (result, val, key) {
                    result.push(val.id + '_' + val.quantity);
                    return result;
                }, []);

                _.forIn(editingItem, function (value, key) {
                    if (_.isArray(value)) {
                        _.forEach(value, function (subVal, loopKey) {
                            formDataObject.append(key + '[]', subVal);
                        });
                    } else {
                        formDataObject.append(key, value);
                    }
                });

                formDataObject.append('_method', 'put');

                axios.request({
                    method: 'post',
                    url: saveUrl,
                    data: formDataObject,
                    config: {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                }).then(response => {
                    that.viewItem(response.data.data);

                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },
            addMaterial() {
                if (!_.isArray(this.new_item.materials)) {
                    this.new_item.materials = [];
                }
                this.new_item.materials.push({
                    id: this.new_material.id.value,
                    name: this.new_material.id.label,
                    quantity: this.new_material.quantity,
                })
                this.new_material = {};
            },
            addMaterialCurrent() {
                this.current_item.materials.push({
                    id: this.new_material_current.id.value,
                    name: this.new_material_current.id.label,
                    quantity: this.new_material_current.quantity,
                })
                this.new_material_current = {};
                this.$forceUpdate();
            },
            deleteItem(itemToDelete) {
                var that = this;
                var title = 'Are you sure you want to remove RFM ' + itemToDelete.reference + '?';
                var description = 'You are removing RFM ' + itemToDelete.reference + '. Are you sure you want to do this?';
                var standardCallback = function (itemToDelete) {
                    let index = that.items.indexOf(itemToDelete);
                    that.items.splice(index, 1);

                    eventBus.$emit('crud-show-new-' + that.name);
                    eventBus.$emit('crud-back-to-nav-' + that.name);
                };

                eventBus.$emit('delete-modal-open', title, description, function () {
                    axios.delete(appUrls.rfm.destroy.replace('REPLACEME', itemToDelete.id));
                    standardCallback(itemToDelete);
                });
            },
            resetErrors() {
                this.errors = null;
            },
            addItem() {
                var that = this;
                var addUrl = appUrls.rfm.store;
                var newItem = $.extend({}, this.new_item);
                var formDataObject = new FormData();


                newItem.materials = _.reduce(newItem.materials, function (result, val, key) {
                    result.push(val.id + '_' + val.quantity);
                    return result;
                }, []);

                _.forIn(newItem, function (value, key) {
                    if (_.isArray(value)) {
                        _.forEach(value, function (subVal, loopKey) {
                            formDataObject.append(key + '[]', subVal);
                        });
                    } else {
                        formDataObject.append(key, value);
                    }
                });

                if(this.packageId){
                  formDataObject.append('package_id', this.packageId);
                }
                formDataObject.append('status_id', 100);
                formDataObject.append('_method', 'post');

                var standardCallback = function (item) {
                    that.items.push(item);
                    that.viewItem(item);

                };

                axios.request({
                    method: 'post',
                    url: addUrl,
                    data: formDataObject,
                    config: {
                        headers: {
                            "Content-Type": "multipart/form-data"
                        }
                    }
                }).then(response => {
                    standardCallback(response.data.data);
                }).catch(function (error) {
                    if (error.response.status === 422) {
                        that.errors = error.response.data.errors;
                    }
                });
            },

            // The Big Daddy Of Methods - Retrieves all methods.
            getItems() {
                var that = this;
                var url = route('api.v1.request-for-materials.index');
                var getVarName = 'rfm';
                var params = {};

                if (this.packageId) {
                    params.package = this.packageId;
                }

                if (this.activeFilter) {
                  params.filter = this.activeFilter;
                }

                axios.get(url, {params: params})
                    .then(response => {
                        that.items = response.data.data;
                        var hasGetVariable = location.search.indexOf(getVarName + '=') >= 0;
                        if (hasGetVariable) {
                            var idFromVariable = getParameterByName(getVarName);
                            if (fieldWithValueExistsInCollection(that.items, 'id', idFromVariable)) {
                                that.viewItem(getItemByFieldAndValue(that.items, 'id', idFromVariable));
                            } else {
                                that.getAndViewItemById(idFromVariable);
                            }
                        }
                    });
            },
            getAndViewItemById(id) {
                var that = this;
                var url = appUrls.rfm.show.replace('REPLACEME', id);

                axios.get(url)
                    .then(response => {
                        that.viewItem(response.data.data);
                    });
            },
            deleteMaterial(material) {
                if (!this.viewing_item) {
                    return;
                }
                let index = this.current_item.materials.indexOf(material);
                this.current_item.materials.splice(index, 1);
                this.$forceUpdate();
            },
            deleteMaterialNew(material) {
                let index = this.new_item.materials.indexOf(material);
                this.new_item.materials.splice(index, 1);
                this.$forceUpdate();
            },
            getMaterials() {
                var that = this;
                var url = appUrls.materials.index;
                var params = {};
                params.compact = true;


                axios.get(url, {params: params})
                    .then(response => {
                        that.materials = [];
                        _.forEach(response.data.data, function (mat) {
                            that.materials.push({
                                label: mat.name,
                                value: mat.id
                            });
                        });
                    });
            },
            viewItem(item) {
                window.eventBus.$emit('crud-view-item-' + this.name, item);
            },
            backToNav: function () {
                window.eventBus.$emit('crud-back-to-nav-' + this.name);
            },
            backToItem: function () {
                window.eventBus.$emit('crud-back-' + this.name);
            },
            setupNewItem: function(){
                this.new_item = {
                    input_type: 'choose',
                    materials: []
                };
            }
        },
        mounted() {
            var that = this;

            if(this.packageId){
              this.activeFilter = 'all';
            }

            this.setupNewItem();

            this.getItems();
            this.getMaterials();

            window.eventBus.$on('crud-filter-activated-' + this.name, function (filterKey) {
              that.activeFilter = filterKey;
              that.getItems();
              that.resetErrors();
            });

            window.eventBus.$on('crud-search-query-changed-' + this.name, _.debounce(function (query) {
                that.search_query = query;
                that.getItems();
            }, 250));

            window.eventBus.$on('crud-search-hidden-' + this.name, function (query) {
                that.search_query = null;
                that.getItems();
            });

            window.eventBus.$on('crud-errors-dismissed', function () {
                that.errors = null;
            });

            window.eventBus.$on('crud-edit-item-' + this.name, function (item) {
                that.setupNewItem();
                that.current_item = item;
                that.resetErrors();
            });

            window.eventBus.$on('crud-delete-item-' + this.name, function (item) {
                that.deleteItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-view-item-' + this.name, function (item) {
                that.setupNewItem();
                that.current_item = item;
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-' + this.name, function (item) {
                that.current_item = item;
                that.viewItem(item);
                that.resetErrors();
            });

            window.eventBus.$on('crud-back-to-nav-' + this.name, function () {
                that.current_item = {};
                that.setupNewItem();
                that.resetErrors();
            });
        }
    }
</script>
